interface Props {
  installed: string;
  useplaceType: string;
}

export const SupportBox = ({ useplaceType, installed }: Props) => {
  if (installed !== "installed") return null;
  return (
    <a
      href={`/kundservice/felsokning/${
        useplaceType === "house" ? "villa" : "lagenhet"
      }`}
      className="text-gray-800 hover:underline"
    >
      <div className="uppercase text-xs">SUPPORT/FELANMÄLAN</div>
      <div>
        Upplever du problem med din uppkoppling? Här guidar vi dig i din
        felsökning och skulle du fortfarande uppleva problem kontaktar du din
        tjänsteleverantör.
      </div>
    </a>
  );
};
